module.exports = __webpack_public_path__ + "img/banner-standapp.18b56099.svg";